import RouteName from '@/models/enums/RouteName'
import CRMPermission from '@/models/enums/permissions/CRMPermission'

export default [
  {
    path: '/administration/fakt-legal-entities',
    name: RouteName.AdministrationFaktLegalEntities,
    component: () => import('@/pages/Administration/FaktLegalEntities/FaktLegalEntityList.vue'),
    meta: {
      permissions: [CRMPermission.ViewAdministrationBilling],
      breadcrumb: {
        label: 'Юрлица FAKT',
        parent: RouteName.Administration,
      },
    },
  },
  {
    path: '/administration/fakt-legal-entities/create',
    name: RouteName.AdministrationFaktLegalEntityCreate,
    component: () => import('@/pages/Administration/FaktLegalEntities/FaktLegalEntityCreate.vue'),
    meta: {
      permissions: [CRMPermission.BillingFaktLegalEntitiesManage],
      breadcrumb: {
        label: 'Новое юрлицо',
        parent: RouteName.AdministrationFaktLegalEntities,
      },
    },
  },
  {
    path: '/administration/fakt-legal-entities/:id',
    name: RouteName.AdministrationFaktLegalEntityEdit,
    component: () => import('@/pages/Administration/FaktLegalEntities/FaktLegalEntitySingle.vue'),
    meta: {
      permissions: [CRMPermission.BillingFaktLegalEntitiesManage],
      breadcrumb: {
        label: 'Редактирование юрлица',
        parent: RouteName.AdministrationFaktLegalEntities,
      },
    },
  },
]
